import { ResultValue, ErrorMessage } from "../../Simple";
import { cleanUpNumberString, containsExcelErrors } from "../../../Utils/stringUtils";

export default function PricingErrors(props) {
    const getPricingErrors = () => {
        const hasClaimError = props.result.claimErrorFlag === 'Y' || props.result.errorFlag === 'Y';
        const hasLineErrors = props.result.services !== undefined && props.result.services.some(s => s.errorFlag === 'Y');
        const cleanedUpMedicareAllowed = cleanUpNumberString(props.totalMedicareAllowed ?? props.result.medicareAllowed);
        const hasNoMedicareAllowed = cleanedUpMedicareAllowed === null || isNaN(cleanedUpMedicareAllowed) || Number(cleanedUpMedicareAllowed) === 0;
        const hasExcelErrors = containsExcelErrors(JSON.stringify(props.result));

        return hasClaimError || hasNoMedicareAllowed || hasLineErrors || hasExcelErrors ? 'Y' : 'N';
    };

    return (<>
        <div className="row">
            <div className="col-md-6">
                <ResultValue label="Pricing Errors" value={getPricingErrors()} labelClassName="fs-4 fw-500" valueClassName="fs-4 fw-500" />
            </div>
        </div>
        {props.result.errors && props.result.errors.length > 0 && (<div className="row">
            <div className="col-md-6">
                <ErrorMessage errors={props.result.errors} />
            </div>
        </div>)}

        {props.result.warnings && props.result.warnings.length > 0 && 
        (<div className="row">
                <div className="col-md-6">
                    <ResultValue label="Pricing warning - while this does not indicate an error, care should be taken while reviewing results:"/>
                    <ErrorMessage errors={props.result.warnings} />
                </div>
        </div>)}
    </>);
}